export const navigationPlacementId = "globalNavHeader";
export const navigationSystemMessagesAppSetting = "enableNavigationSystemMessages";
export const notificationCenterAction = "GLOBALNAVALERT";
